import {useState} from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Space,
  Typography,
  notification,
} from 'antd';
import {
  CheckCircleOutlined,
  GlobalOutlined,
  TagOutlined,
} from '@ant-design/icons';
import {useHistory} from 'react-router-dom';
import {ProgramsNewService} from './ProgramsNewService';
import type {CreateNewProgramInput} from '@PikaDoApp/npm-pikado-logic/dist/modules/program/graphql/program.interface';
import {useSelector} from 'react-redux';

const {Title, Text} = Typography;

const programsService = new ProgramsNewService();

export const ProgramCreate = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const currentUser = useSelector((state: any) => state.user?.userProfile);

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      setIsSubmitting(true);

      const programInput: CreateNewProgramInput = {
        name: values.name.trim(),
        createdBy: currentUser?.email ?? 'unknown',
      };

      await programsService.createNewProgram(programInput);

      notification.success({
        message: 'Program Created!',
        description: `"${values.name}" has been created successfully.`,
        duration: 4,
      });

      setTimeout(() => history.push('/programs'), 1200);
    } catch (err: any) {
      if (err?.errorFields) return;
      notification.error({
        message: 'Failed to Create Program',
        description: err?.message || 'An unexpected error occurred.',
        duration: 6,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const formValues = Form.useWatch([], form);

  return (
    <div style={{padding: '24px 32px', maxWidth: 720, margin: '0 auto'}}>
      <Title level={2} style={{textAlign: 'center', marginBottom: 32}}>
        Create New Program
      </Title>

      <Form form={form} layout="vertical" initialValues={{}}>
        {/* ── Program Name ── */}
        <Card
          title={
            <>
              <TagOutlined /> &nbsp; Program Information
            </>
          }
          style={{marginBottom: 16}}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="name"
                label="Program Name"
                rules={[{required: true, message: 'Program name is required'}]}>
                <Input placeholder="e.g. English Program" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* ── Review ── */}
        <Card
          title={
            <>
              <CheckCircleOutlined /> &nbsp; Review
            </>
          }
          style={{marginBottom: 24}}>
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <Text type="secondary">Program Name</Text>
              <br />
              <Text strong>{formValues?.name || '-'}</Text>
            </Col>
          </Row>
        </Card>

        {/* Actions */}
        <div style={{textAlign: 'center'}}>
          <Space>
            <Button size="large" onClick={() => history.goBack()}>
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              icon={<GlobalOutlined />}
              loading={isSubmitting}
              onClick={handleCreate}
              style={{minWidth: 180}}>
              Create Program
            </Button>
          </Space>
        </div>
      </Form>
    </div>
  );
};
